import {HiOutlineMail} from 'react-icons/hi'
import { FaLinkedin, FaPhoneSquareAlt, FaInstagramSquare } from 'react-icons/fa'

const data = [
    {id: 1, icon: <HiOutlineMail/>,target:'_self', link: 'mailto:jayeshsolanki19.js@gmail.com'},
    {id: 2, icon: <FaPhoneSquareAlt/>,target:'_self', link: 'tel:+919624882417'},    
    {id: 3, icon: <FaLinkedin/>,target:'_blank', link: 'https://www.linkedin.com/in/jayesh-solanki-dev/'},
    {id: 4, icon: <FaInstagramSquare/>,target:'_blank', link: 'https://www.instagram.com/jayeshsolanki_1307/'}
]
export default data